import { FC } from 'react';

export const SearchHelpTooltip: FC = () => (
  <span>
    <strong>Available filter types:</strong>
    <br />
    1) <strong>Text Search:</strong> Enter text to search for (e.g. &apos;vm01&apos;)
    <br />
    2) <strong>RegEx Search:</strong> Use{' '}
    <a
      className='help-regex-link'
      href='https://xormon.com/regular_expression.php'
      target='_blank'
      rel='noopener noreferrer'
    >
      regular expressions
    </a>{' '}
    for advanced searching
    <br />
    3) <strong>Network Filters:</strong> IP address (e.g. &apos;10.22&apos;), MAC address (e.g.
    &apos;00:11:22:33:44:55&apos;), WWN (e.g. &apos;10:00:00:05:1e:7a:7a:00&apos;)
    <br />
    4) <strong>Storage Filters:</strong> Volume ID (e.g.
    &apos;6005076300808AE5100000000000001A&apos;), Health Status (e.g. &apos;OK&apos;,
    &apos;Warning&apos;, &apos;Error&apos;, &apos;Unknown&apos;, &apos;Ignored&apos;)
    <br />
    5) <strong>Tags:</strong> Select one or multiple tags from dropdown list
    <br />
    6) <strong>Architecture Filters:</strong> Class + Subsystem (e.g. &apos;SAN → Device&apos;), HW
    Type + Subsystem (e.g. &apos;VMware → VM&apos;)
    <br />
    <br />
    <em>You can combine different filter types for precise searching</em>
    <br />
    View more details in{' '}
    <a
      className='help-regex-link'
      href='https://xormon.com/search-application.php'
      target='_blank'
      rel='noopener noreferrer'
    >
      online documentation
    </a>
  </span>
);
